<template>
  <div class="login-register">
    <link href="static/css/pages/login-register-lock.css" rel="stylesheet">
    <div class="login-box card">
      <div class="card-body">
        <p class=""><img src="../assets/achiev-logo.svg" alt="homepage" class="dark-logo" /></p>

        <div v-show="!forgotten" class="form-horizontal form-material">
          <h3 class="box-title m-b-20">{{ $t("Sign In") }}</h3>
          <div class="form-group " v-bind:class="{'has-danger': loginError}">
            <div class="col-xs-12">
              <input class="form-control" type="text" v-on:keyup.enter="signIn()" v-model="user.email" :placeholder="$t('E-mail address')" autofocus>
              <small class="form-control-feedback" v-show="loginError">{{ $t("Username/password incorrect") }}</small>
            </div>
          </div>
          <div class="form-group" v-bind:class="{'has-danger': loginError}">
            <div class="col-xs-12">
              <input class="form-control" type="password" v-on:keyup.enter="signIn()" v-model="user.password" :placeholder="$t('Password')">
              <small class="form-control-feedback" v-show="loginError">{{ $t("Username/password incorrect") }}</small>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-12">
              <div class="checkbox checkbox-info pull-left p-t-0">
                <input id="checkbox-signup" type="checkbox" class="filled-in chk-col-light-blue" v-model="remember">
                <label for="checkbox-signup"> {{ $t("Remember me") }} </label>
              </div>
              <a v-on:click="forgotten = !forgotten" id="to-recover" class="text-info pull-right">
                {{ $t("Forgot password?") }}
              </a>
            </div>
          </div>
          <div class="form-group text-center">
            <div class="col-xs-12 p-b-20">
              <button class="btn btn-block btn-lg btn-info btn-rounded" v-on:click="signIn()" v-show="!signingIn">{{ $t("Log In") }}</button>
              <button class="btn btn-block btn-lg btn-light btn-rounded" v-show="signingIn">{{ $t("Please wait...")}}</button>
            </div>
          </div>
        </div>
        <div v-show="forgotten">
          <div class="form-group">
            <div class="col-xs-12">
              <h3>Recover Password</h3>
              <p class="text-muted">{{ $t("Enter your Email and instructions will be sent to you!") }}</p>
            </div>
          </div>
          <div class="form-group ">
            <div class="col-xs-12">
              <input class="form-control" type="email"  placeholder="Email" v-model="forgottenEmail"> </div>
            <small v-if="resetSuccessful" class="success">{{ resetMessage }}</small>
            <small v-if="invalidEmail" class="text-danger">{{ $t("Invalid e-mail address") }}</small>
          </div>
          <div class="form-group text-center m-t-20">
            <div class="col-xs-12">
              <button class="btn btn-rounded btn-info btn-lg btn-block waves-light" type="button" v-on:click="forgotPassword">{{ $t("Reset") }}</button>
            </div>
          </div>
          <div class="text-center">
          <a @click="forgotten = !forgotten">{{ $t("Cancel") }}</a>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import base64 from 'base-64';
  import router from '../router';
  import apiHelper from '../mixins/APIHelper';

  export default {
    name: "login",
    data: function () {
      return {
        user: {
          password: "",
          email: ""
        },
        next: "",
        forgottenEmail: "",
        forgotten: false,
        remember: false,
        loginError: false,
        resetMessage: "",
        resetSuccessful: false,
        invalidEmail: false,
        signingIn: false
      }
    },
    methods: {
      signIn: function () {
        let vm = this;
        let headers = new Headers();

        vm.signingIn = true;
        vm.$baseUrl = __API__;
        headers.append("Authorization", "Basic " + base64.encode(vm.user.email + ":" + vm.user.password));
        headers.append("Content-Type", "application/json");
        headers.append("Accept", "application/json");
        fetch(vm.$baseUrl + "/api/auth",
          {
            body: JSON.stringify({
              username: vm.user.email,
              password: vm.user.password
            }),
            method: "POST",
            headers: headers,
            mode: "cors",
            credentials: "include",
          }
        )
          .then((response) => {
            return response.json();
          })
          .then((data) => {
            if(data.hasOwnProperty("token")) {
              vm.loginError = false;
              localStorage.clear();
              localStorage.setItem("achiev_token", data.token);
              localStorage.setItem("user_uid", data.uid);
              localStorage.setItem("expires", data.expires);
              vm.grabUserData(data.uid);
            } else {
              vm.loginError = true;
              vm.signingIn = false;
            }
          });

      },
      forgotPassword: function () {
        let vm = this;
        if (this.forgottenEmail.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/) !== null) {

          apiHelper.postResource("/api/user/recover", {
            username: this.forgottenEmail
          }).then(function (data) {
            vm.resetSuccessful = true;
            vm.resetMessage = data.message;
            vm.invalidEmail = false;
          });
        }else{
          vm.invalidEmail = true;
          vm.resetMessage = "";
        }
      },

      grabUserData: function (uid) {
        let vm = this;
        let data_to_send = {
          "include": "Orgunits,Settings"
        };
        apiHelper.getResource("/api/user/{uid}", data_to_send).then((data) => {
          let user_data = data.data;
          apiHelper.setUserData(user_data);
          if (typeof vm.$route.query.next === 'undefined') {
            vm.$router.push("/dashboard");
          } else {
            if (!vm.$route.query.next.includes("login")) {
              vm.$router.push(vm.$route.query.next);
            }else{
              vm.$router.push("/dashboard");
            }
          }
        });
      }
    }
  }
</script>

<style scoped>
  .login-register{
    background: url("/static/img/login.jpg") no-repeat;
    background-size: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue